<template>
	<el-dialog :visible.sync="showsetwxtemp" title="设置模板" :width="winwidth" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false">
		<div class="wxtemp">
			<el-row style="margin-bottom:5px;">
				<el-col :span="1" style="color:transparent">1</el-col>
				<el-col :span="8" style="text-align: center;" v-if="ewmsrc!=''"><span>微信扫码看示例</span></el-col>
				<el-col :span="10" style="color:transparent">1</el-col>
			</el-row>
			<el-row>
				<el-col :span="1" style="color:transparent">1</el-col>
				<el-col :span="8" v-if="ewmsrc!=''">
					<div style="text-align:center;">
						<el-image :src="ewmsrc">
							<div slot="error" class="image-slot">
							     {{loadtext}}
							</div>
							<div slot="placeholder" class="image-slot">
								加载中
								<span class="dot">...</span>
							</div>
						</el-image>
					</div>
				</el-col>
				<el-col :span="1" style="text-align:center;" v-if="ewmsrc!=''"><div class="line"></div></el-col>
				<el-col :span="contextspan">
					<table style="width:100%">
						<tr v-for="(item, index) in w_fixed" :key="index">
							<td style="width:100px;text-align:right;padding-right:10px;">
								<label>{{item.label}}</label>
							</td>
							<td>
								<el-input type="text" size="mini" placeholder="可输入自定义内容" v-if="item.value != undefined" v-model="item.value"></el-input>
								<span type="text" :style="{color:`${item.color}`}" v-if="item.value == undefined">{{ item.value1 }}</span>
							</td>
							<td style="width:50px;text-align:center;">
								<el-color-picker v-model="item.color" size="mini"></el-color-picker>
							</td>
						</tr>
					</table>
				</el-col>
			</el-row>
		</div>
		<div style="text-align: center;width:100%;padding-top:20px">
			<el-button size="mini" type="warning" @click.native="savewxtemp(true)">保存并预览</el-button>
			
			<el-button size="mini" type="success" @click.native="savewxtemp(false)">保存</el-button>
			<el-button size="mini" type="info"  plain @click.native="showsetwxtemp = false">取消</el-button>
		</div>
	</el-dialog>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {},
	data() {
		return {
			divclass: 'wxtemp',
			showsetwxtemp: false,
			w_fixed: [],
			ewmsrc: '',
			contextspan:22,
			winwidth:'550px',
			id:'',
			loadtext:''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/msg/wxtemp.scss');
		});
	},
	methods: {
		init(param) {
			this.w_fixed = [];
			this.ewmsrc='';
			this.id=param.id;
			this.contextspan=22;
			this.winwidth='550px';
			this.showsetwxtemp = true;
			this.GetRemindTempSet();
		},
		GetRemindTempSet(){
			var that=this;
			this.$apipost.get.GetRemindTempSet({id:this.id}).then(res => {
				if (res != '') {
					if(res.state=='1'){
						if(res.info!=''){
							that.w_fixed = res.info;
						}
					}else{
						this.$tool.message(res.message,0);
					}
				}
			});
		},
		//保存微信模板
		savewxtemp(isperview) {
			var that=this;
			var paraminfo={
				id:this.id,
				w_fixed:JSON.stringify(this.w_fixed)
			}
			this.$apipost.post.SaveRemindSet({paraminfo:paraminfo}).then(res => {
				if (res != '') {
					if(res.state=='1'){
						if(isperview){
							that.createewm();
						}else
							that.showsetwxtemp=false;
					}
				}
			});
		},
		//生成示例二维码
		createewm(){
			var that=this;
			var paraminfo={
				type:'发送微信模板示例',
				value:{
					id:this.id,
					info:{
						u_userid:localStorage.getItem('userid'),
						wxopenid:'',
						p_pkval:'TEST00001',
						expressid:'123456789012',
						expresscom:'顺丰',
						cgname:'张三',
						cgphone:'13250503808',
						cgprovince:'广东省',
						cgcity:'广州市',
						cgdistrict:'花都区',
						cgstreet:'',
						cgdetailaddr:'迎宾大道',
						p_orderstate:'已揽收',
						ctname:'李四',
						ctphone:'13250503808',
						ctprovince:'北京',
						ctcity:'北京',
						ctdistrict:'东城区',
						ctstreet:'',
						ctdetailaddr:'天安门',
						nickname:'快递飞',
						result:''
					}
				}
			};
			this.$apipost.get.CreateTempEwm({paraminfo:paraminfo}).then(res => {
				if (res != '') {
					if(res.state=='1'){
						that.ewmsrc=res.img;
						that.contextspan=14;
						that.winwidth="750px";
					}else{
						that.loadtext=res.message;
						//this.$tool.message(res.message, 0);
					}
				}
			});
		}
	}
};
</script>

<style></style>
